import React from "react";
import LabelWithStatus from "./label-with-status";

const DocumentUploadWithStatus = ({
  id,
  label,
  required = false,
  fieldData, // { value, status }
  handleStatusClick,

  fileRef,
  onChange,
  onFileClick,
  onDelete,

  accept = ".pdf,.png,.jpeg",
  allowedTypes = ["PNG", "JPEG", "PDF"],
  maxSize = "< 10 MB",
}) => {
  const isRejected = fieldData?.status === "rejected";
  const isApproved = fieldData?.status === "approved";

  return (
    <>
      {/* Label with status */}
      <LabelWithStatus
        id={id}
        label={label}
        required={required}
        fieldData={fieldData}
        handleStatusClick={handleStatusClick}
      />

      {/* Upload box */}
      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
        <input
          type="file"
          id={`${id}-upload`}
          accept={accept}
          ref={fileRef}
          onChange={onChange}
          className="hidden"
          disabled={isApproved}
        />

        <img src="/folder-add.svg" alt="Upload" className="h-4 w-4" />

        <p className="mt-2 text-gray-500 text-sm">
          Drag & Drop <br />
          or <span className="underline">Click to Upload</span>
        </p>
      </label>

      {/* File type info */}
      <div className="mt-1 flex flex-wrap gap-2">
        {allowedTypes.map((type) => (
          <span
            key={type}
            className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs"
          >
            {type}
          </span>
        ))}
        <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
          {maxSize}
        </span>
      </div>

      {/* Uploaded file */}
      {fieldData?.value && (
        <div
          className={`mt-4 bg-white shadow-md rounded-lg flex items-center justify-between px-3 py-2 ${
            isRejected ? "border-2 border-[#FF5050]" : "border"
          }`}
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              onFileClick?.(e, fieldData.value);
            }}
            className="flex flex-col cursor-pointer"
          >
            <span className="text-black underline">
              {fieldData.value.file_name}
            </span>
            <span className="text-[#46DA55] text-xs">
              Upload Completed
            </span>
          </div>

          {!isApproved && (
            <button
              onClick={onDelete}
              className="text-red-500 flex-shrink-0 font-semibold"
            >
              <img src="/trash.svg" alt="Delete" className="h-4 w-4" />
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default DocumentUploadWithStatus;